import {
  IVerifoneTransactionExtendedData,
  TransactionStatus,
  isVerifoneTransactionExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class ApproveVerifoneTransaction
  implements ITransactionAction<IVerifoneTransactionExtendedData>
{
  icon = 'done';
  label = 'Approve';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isVerifoneTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IVerifoneTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isVerifoneTransactionExtendedData
    ).pipe(
      map((transaction) => transaction?.status === TransactionStatus.Pending)
    );
  }

  async do(
    data: ITransactionActionsData<IVerifoneTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    try {
      await this._actions.approve(
        data.invoice,
        data.latestTransaction,
        'Approve Transaction'
      );
    } finally {
      this.inProgress$.next(false);
    }
  }
}
